import _ from "lodash";

export class GroupNode {
  constructor(group, allLevelCount) {
    this.data = { value: group?.id ?? null, label: group?.name ?? "[ALL]" };
    this.level = group?.level ?? 0;
    this.children = [];
    this.childrenValue = [];
    this.parent = null;
    this.allLevelCount = allLevelCount;
  }

  addChild(child) {
    this.children.push(child);
    this.childrenValue.push(child.data);
  }

  removeChild(child) {
    const newChildren = this.children.filter((c) => {
      return c.data.value !== child.data.value;
    });
    const newChildrenValue = this.childrenValue.filter((cv) => {
      return cv.value !== child.data.value;
    });
    this.children = newChildren;
    this.childrenValue = newChildrenValue;
  }

  findNode(value) {
    if (value === null || value === undefined) return new GroupNode();
    if (this.data.value === value) {
      return this;
    }
    for (let child of this.children) {
      const foundNode = child.findNode(value);
      if (foundNode !== null) {
        return foundNode;
      }
    }
    return null;
  }

  getChildrenSelectOptions(isAll = false) {
    if (this.level === 0 && this.children.length === 0) {
      return [{ value: null, label: "[ALL]" }];
    }
    let result = this.childrenValue;
    if (isAll && this.children.length === this.allLevelCount) {
      result = [{ value: null, label: "[ALL]" }, ...result];
    }
    return result;
  }
}

export const getGroupPath = (root, leaf) => {
  if (!root) return [];
  const dfs = (node, path = []) => {
    if (node === null) {
      return null;
    }
    path.push(node);
    if (node.data.value === leaf.data.value) {
      return path;
    }
    if (node.children) {
      for (let child of node.children) {
        let foundPath = dfs(child, path.slice());
        if (foundPath) {
          return foundPath;
        }
      }
    }
    return null;
  };
  return dfs(root);
};

export const createGroupTree = (groupList, groupAndChildren) => {
  const root = new GroupNode(null, groupAndChildren["all_count"][1]);
  const addChildren = (parent) => {
    try {
      if (groupAndChildren[parent.data.value]?.length > 0) {
        groupAndChildren[parent.data.value].forEach((g) => {
          if (_.find(groupList[parent.level + 1], { id: g.id })) {
            const tmp = new GroupNode(g, groupAndChildren[g.id]?.length ?? 0);
            parent.addChild(tmp);
            tmp.parent = parent;
            addChildren(tmp);
          }
        });
      }
    } catch (e) {
      //
    }
  };
  groupList[1].forEach((firstLevelGroup) => {
    const firstLevelGroupNode = new GroupNode(
      firstLevelGroup,
      groupAndChildren[firstLevelGroup.id].length
    );
    firstLevelGroupNode.parent = root;
    root.addChild(firstLevelGroupNode);
    addChildren(firstLevelGroupNode);
  });
  return root;
};

export const findNodeByName = (node, name, level, result = []) => {
  if (node.data.label === name && node.level === level) {
    result.push(node);
  }
  for (let child of node.children) {
    findNodeByName(child, name, child.level, result);
  }
  return result;
}

export const getSelectOptionsByName = (nodes, level, filterList, hasAll = true) => {
  const checkParent = (current) => {
    for (let i = level - 1; i >= 1; i--) {
      let parent = current.parent;
      if (filterList[i]?.value && parent.data.label !== filterList[i]?.value) {
        return false;
      }
      current = parent;
    }
    return true;
  }
  const dfs = (n, result = []) => {
    if (n?.level === level && checkParent(n)) {
      result.push(n);
    }
    if (n?.children) {
      for (let child of n.children) {
        dfs(child, result);
      }
    }
    return result;
  };

  let nodesInLevel = [];
  for (let node of nodes) {
    let nodes = dfs(node);
    nodesInLevel = [...nodesInLevel, ...nodes];
  }
  let result = hasAll ? [{ value: null, label: "[ALL]" }] : [];
  for (let node of nodesInLevel) {
    if (_.some(result, { value: node.data.label }) === false) {
      result.push({ value: node.data.label, label: node.data.label });
    }
  }
  return result;
};
